<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zTAAhY/tc-custom/9798337200767.jpg?1737543888273" alt="This image is the cover for the book Widow's Web"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Widow's Web
      </h1>
      <p class="bookDescription body article font2">
        <b>When her tycoon husband suddenly dies, a woman discovers the sinister secrets of Silicon Valley, in this psychological thriller debut.</b><br/><br/> When tech mogul Brad Jones is found drowned off the Marin coast, his death is quickly ruled a suicide. But his wife, Dr. Anna Jones, a renowned cyberpsychologist, isn’t convinced. Driven by grief and suspicion, Anna begins to dig into Brad’s past, uncovering some dark details behind Silicon Valley’s elite.<br/><br/> Anna soon crosses paths with Scott and Kristy Lyle, influential figures with connections reaching the highest echelons of the tech industry. The deeper she goes, the more she realizes Brad’s death is tied to a long-buried secret—one that powerful people would kill to protect. Caught between the truth and some dangerous enemies, will Anna risk everything to expose the sinister forces at play?<br/><br/><i>The Widow’s Web</i> is a gripping psychological thriller that explores ambition, betrayal, and the terrifying reality that our worst enemies may be those we trust the most.<br/><br/> “In <i>The</i><i>Widow’s Web</i>, Susan Moore gives us the inside story of what really happens in Silicon Valley—not the start ups and IPOs but the depravity and decadence of the ultra-rich who despite all their wealth can’t escape their own demons.” —Karl Taro Greenfeld, journalist and award-winning author<br/><br/> “A gripping page-turner from start to finish, <i>The Widow’s Web</i> is a mesmerizing blend of suspense and mystery, luring readers into a dark tangle of secrets with each unpredictable twist.” —Lisa C. Carey, bestselling author<br/><br/> “Expertly plotted, gripping and impossible to put down.” —Lorna Henderson, author of <i>Two Sisters</i><br/><br/> “Susan Moore writes a compelling and heartbreaking psychological thriller about ordinary people making unimaginable choices. Her pared down narrative and attention to detail reminded me of Gillian Flynn.” —Faiqa Mansab, award-winning author of <i>This House of Clay and Water</i><br/><br/> “Intriguing and compelling.” —Paul Perry, author of <i>The Garden</i><br/><br/> “A superbly written tale of dark secrets, raging beneath a facade of sophistication and success.” —Andy Elkerton, <i>New York Times</i>–bestselling author<br/><br/> “Susan is committed to creating exceptional stories with a far-reaching impact.” —Gary W. Goldstein, producer of <i>Pretty Woman</i><br/><br/> “Susan has a fantastic instinct for searing contemporary storytelling driven by intensely character driven plotting.” —Katherine Lannon, Script Angel screenwriting coach
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Moore
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2f232cd0